import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { CompliantVsNonCompliantMetricsResponse } from '../_types';

export async function getTrainingComplianceSummary(
  orgId: string,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<CompliantVsNonCompliantMetricsResponse> {
  try {
    const url = `${baseApiUrl()}/insights-center/v1/organizations/${orgId}/training/compliance-summary`;
    const response: CompliantVsNonCompliantMetricsResponse = await fetcher({
      method: 'GET',
      url,
      options: { signal },
    });

    return response;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
}

export default function useTrainingComplianceSummary(
  orgId: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<CompliantVsNonCompliantMetricsResponse, ServerErrorResponse>(
    ['training_compliance_summary', orgId],
    async ({ signal }): Promise<CompliantVsNonCompliantMetricsResponse> => {
      return getTrainingComplianceSummary(orgId, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId,
    }
  );
}
